<div #dropdown>
    <button
        appMenuButton
        appNavItem
        [position]="position"
        [dropdownEl]="dropdown"
        [ariaControls]="listId"
        type="button"
        class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2"
        buttonDataTest="meButton"
    >
        <div [ariaHidden]="true" class="tw-flex tw-justify-center tw-relative">
            @if ((canAccessNotifications$ | async) && notificationCount) {
                <span class="tw-size-1.5 tw-bg-danger tw-rounded-full tw-absolute -tw-right-0.5 tw-translate-x-full"></span>
            }
            <app-profile-avatar size="xs" />
        </div>
        <div class="tw-flex tw-items-center tw-gap-1">
            <span class="nav-item-text" [ngClass]="(open$ | async) ? 'tw-text-primary' : ''" translate>v3-globale-me</span>
            <app-icon
                class="tw-size-3 tw-transition-transform tw-duration-[400ms]"
                name="point-arrow-down"
                [ngClass]="(open$ | async) ? 'tw-fill-primary tw-rotate-180' : ''"
            />
        </div>
    </button>

    <app-header-menu [open]="open$ | async" />
</div>
